import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

type HeaderButtonProps = {
  headerButtonOutletId?: string;
  link?: string;
  children: React.ReactNode;
};

const HeaderButton = ({
  headerButtonOutletId = 'default-header-button',
  children,
}: HeaderButtonProps): React.ReactNode => {
  const [headerButtonOutlet, setHeaderButtonOutlet] =
    useState<HTMLOListElement>();

  useEffect(() => {
    const outletElement = document.getElementById(
      headerButtonOutletId,
    ) as HTMLOListElement;
    if (outletElement) {
      setHeaderButtonOutlet(outletElement);
    }
  }, [headerButtonOutletId]);

  if (!headerButtonOutlet) {
    return <></>;
  }

  return (
    <>
      {createPortal(
        <div className='vnm-grid-cols-2 vnm-space-x-1'>{children}</div>,
        headerButtonOutlet,
      )}
    </>
  );
};

export default HeaderButton;
